import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ApiService } from '../admin/api.service';

export type RegistrationStatus = 'new' | 'pending' | 'registered';

export interface PatientCheckResult {
  success: boolean;
  exists: boolean;
  status: RegistrationStatus;
  message: string;
  data?: {
    full_name: string;
    patient_number: string;
  };
}

export interface PatientRegisterResult {
  success: boolean;
  message: string;
  exists?: boolean;
  status?: RegistrationStatus;
  data?: {
    full_name: string;
    patient_number: string;
  };
}

@Injectable({
  providedIn: 'root',
})
export class PublicRegistrationService {
  private readonly apiUrl: string;

  constructor(private http: HttpClient, private apiService: ApiService) {
    this.apiUrl = this.apiService.getBaseUrl();
  }

  checkPatient(payload: {
    full_name: string;
    contact_number: string;
  }): Observable<PatientCheckResult> {
    return this.http.post<PatientCheckResult>(
      `${this.apiUrl}/public/patient/check`,
      payload
    );
  }

  registerPatient(payload: {
    salutation?: string | null;
    full_name: string;
    age: number;
    contact_number: string;
    email?: string | null;
    address?: string | null;
    city?: string | null;
    state?: string | null;
    pincode?: string | null;
    occupation?: string | null;
    company?: string;
  }): Observable<PatientRegisterResult> {
    return this.http.post<PatientRegisterResult>(
      `${this.apiUrl}/public/patient/register`,
      payload
    );
  }
}
